import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { faqs } from "../data/landing";
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(null);
  return <section id="faq" className="bg-canvas" data-id="element-82" data-mp="1gitws6qmn0ks">
      <div className="mx-auto max-w-3xl px-5 py-16 md:py-24" data-id="element-83" data-mp="1glpt5qmtth74">
        <SectionHeading title="Frequently Asked Questions" data-id="element-84" data-mp="24a93sctcm62d" />

        <ul className="mt-10 space-y-3" data-id="element-85" data-mp="28arto1bol21x">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          const panelId = `faq-panel-${i}`;
          return <li key={faq.q} className="rounded-2xl bg-white px-5 shadow-[0_6px_20px_-14px_rgba(11,24,56,0.3)] md:px-6" data-id="element-86" data-mp="1uj4nn9rxsf5y" data-mpi={i}>
                <h3 data-id="element-87" data-mp="1zg4uvo0ivnyn">
                  <button type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 py-5 text-left focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-royal" data-id="element-88" data-mp="2n7imfrqunfik">
                    <span className="font-display text-[17px] font-bold leading-snug text-ink" data-id="element-89" data-mp="10tp38on574xz">{faq.q}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-royal transition-transform duration-200 ease-out ${isOpen ? "rotate-180" : ""}`} strokeWidth={2.5} aria-hidden="true" data-id="element-90" data-mp="1ektv34k9qsxr" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-91" data-mp="1ohyhn5i10qf3">
                  {isOpen && <motion.div id={panelId} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-92" data-mp="1jkggi1a93fhn">
                      <p className="pb-5 pr-6 leading-relaxed text-ink-soft" data-id="element-93" data-mp="3udaxlxmi94x4">{faq.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}